export const WIDGET_LIST = {
  HISTORY: 'history',
  PRODUCT: 'product',
  DOCUMENT: 'document',
  CLIENT: 'client',
  UPLOAD: 'upload',
} as const;

export type WidgetList = (typeof WIDGET_LIST)[keyof typeof WIDGET_LIST];
